module.exports = (__parcel__import__("497Ww")).then(() => parcelRequire('emu4l'));